import { IconButton, Tooltip, colors } from '@sweep-io/sweep-design';
import { IconProps } from '@sweep-io/sweep-design/dist/icons/common';
import React from 'react';

const ICON_COLOR = colors.grey[900];

export const CanvasToolbarButton = ({
  children,
  onToggle,
  pressed,
  disabled,
  tooltip,
  disabledTooltip,
}: {
  children: React.ReactElement<IconProps>;
  onToggle: (pressed: boolean) => void;
  pressed?: boolean;
  disabled?: boolean;
  tooltip?: string | React.ReactElement;
  disabledTooltip?: string;
}) => {
  const Icon = React.cloneElement(children, { color: ICON_COLOR, variant: 'default' });
  return (
    <Tooltip title={disabled ? disabledTooltip : tooltip} placement="bottom">
      <span>
        <IconButton
          variant="squared"
          onClick={() => onToggle(!pressed)}
          pressed={pressed}
          disabled={disabled}
          size="small"
        >
          {Icon}
        </IconButton>
      </span>
    </Tooltip>
  );
};
